import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators as bind } from 'redux';


import Picker from '../components/GoalsFlow/Picker';
import GoalsFlow from '../components/GoalsFlow/Flow';
import Results from '../components/GoalsFlow/Results';

import { Goals, Emails } from '../data/ducks';
import { firstQuestion, lastQuestion } from '../constants/questionnaires';
import { getUserAgeFromGoal, getUserSavingsFromGoal, mp } from '../constants/utils';

const GoalsSteps = [
  Picker,
  GoalsFlow,
  Results,
];

class GoalsContainer extends Component {
  state = {
    currentStep: 0,
    totalSteps: GoalsSteps.length,
  };

  setUserPlan = (goals) => {
    // eslint-disable-next-line
    const { age } = getUserAgeFromGoal(goals[0]);
    // eslint-disable-next-line
    const { current_savings } = getUserSavingsFromGoal(goals[goals.length - 1]);
    return ({
      age,
      current_savings,
      financial_goals: goals,
    });
  };

  nextStep = () => {
    const { currentStep, totalSteps } = this.state;
    if (currentStep < (totalSteps - 1)) {
      this.setState(state => ({ currentStep: state.currentStep + 1 }));
    }
  };

  // FIXME: Change this function to what it was in the past.

  injectFirstQuestions = (questionnaire = []) => {
    const newQuestionnaire = [...questionnaire];

    if (newQuestionnaire[0].questions[0].inputName !== 'age') {
      newQuestionnaire[0].questions = [...firstQuestion, ...questionnaire[0].questions];
    }

    const lastQuestionnairePosition = newQuestionnaire.length - 1;
    const lastQuestionOfLastQuestionnaire = newQuestionnaire[lastQuestionnairePosition].questions.length - 1;
    if (newQuestionnaire[lastQuestionnairePosition].questions[lastQuestionOfLastQuestionnaire].inputName !== 'initialSavings') {
      newQuestionnaire[lastQuestionnairePosition].questions = [...questionnaire[lastQuestionnairePosition].questions, ...lastQuestion];
    }

    return newQuestionnaire;
  }


  handleStepSubmit = (data) => {
    switch (this.state.currentStep) {
      case 0:
        this.setState({ questionnaire: this.injectFirstQuestions(data.goals) });
        break;
      case 1:
        mp('Metas | Obtener Plan');
        this.props.createPlan(this.setUserPlan(data));
        break;
      case 2:
        this.props.sendEmail({
          email: data.values.email,
          objectID: data.planId,
        });
        break;
      default: break;
    }
    this.nextStep();
  }

  render() {
    const CurrentStep = GoalsSteps[this.state.currentStep];
    return (
      <Fragment>
        <CurrentStep
          nextStep={this.nextStep}
          onStepSubmit={this.handleStepSubmit}
          questionnaire={this.state.questionnaire}
          plan={this.props.plan}
          injectNewQuestions={this.injectNewQuestions}
          failed={this.props.failed}
        />
      </Fragment>
    );
  }
}

GoalsContainer.propTypes = {
  plan: PropTypes.object,
  createPlan: PropTypes.func,
  sendEmail: PropTypes.func,
};

GoalsContainer.defaultProps = {
  plan: {},
  createPlan: () => {},
  sendEmail: () => {},
};

const mapStateToProps = state => ({
  plan: state.goals.plan,
  failed: state.goals.error,
  // someData: Goals.Selectors.getData(state), // INFO:
});

const mapDispatchToProps = dispatch => bind({
  createPlan: Goals.Creators.createPlanRequested,
  sendEmail: Emails.Creators.sendEmailQuoteRequested,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(GoalsContainer);
